import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';

import rootReducer from './reducers/root.reducer';
import rootSaga from './sagas/root.saga';

export function configureStore(initialState = {}) {
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [sagaMiddleware, thunk];

  let composeEnhancers = compose;
  if (
    process.env.NODE_ENV === 'development' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ // eslint-disable-line
  ) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__; // eslint-disable-line
  }

  const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));
  sagaMiddleware.run(rootSaga);
  if (process.env.NODE_ENV === 'development' && import.meta.hot) {
    import.meta.hot.accept('./reducers/root.reducer', (module) => {
      const nextReducer = module.default;
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}
